export const getTagStyle = () => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 36,
    paddingLeft: 4,
    paddingRight: 4,
    background: '#e9ebee',
    border: '1px solid #9cb4d8',
    borderRadius: '4px',
    '& .text': {
      lineHeight: '32px',
      cursor: 'default',
    },
  },
});
